export const SITEINFO_LIST_ACTION = "SITEINFO_LIST_ACTION";
export const SITEINFO_LIST_SUCCESS = "SITEINFO_LIST_SUCCESS";
export const SITEINFO_LIST_FAIL = "SITEINFO_LIST_FAIL";
export const SITEINFO_DELETE_TRANSLATE_SUCCESS = "SITEINFO_DELETE_TRANSLATE_SUCCESS";

export const SITEINFO_DETAIL_ACTION = "SITEINFO_DETAIL_ACTION";
export const SITEINFO_DETAIL_DELETE_ACTION = "SITEINFO_DETAIL_DELETE_ACTION";
export const SITEINFO_DETAIL_SUCCESS = "SITEINFO_DETAIL_SUCCESS";
export const SITEINFO_DETAIL_FAIL = "SITEINFO_DETAIL_FAIL"

export const SITEINFO_DETAIL_UPDATE_ACTION = "SITEINFO_DETAIL_UPDATE_ACTION";
export const SITEINFO_DETAIL_CREATE_ACTION = "SITEINFO_DETAIL_CREATE_ACTION";

export const SITEINFO_CREATE_TRANSLATE_ACTION = "SITEINFO_CREATE_TRANSLATE_ACTION";
export const SITEINFO_UPDATE_TRANSLATE_ACTION = "SITEINFO_UPDATE_TRANSLATE_ACTION";
export const SITEINFO_DELETE_TRANSLATE_ACTION = "SITEINFO_DELETE_TRANSLATE_ACTION";

export const SITEINFO_CREATE_TRANSLATE_SUCCESS = "CATEGORY_CREATE_TRANSLATE_SUCCESS";
export const SITEINFO_UPDATE_TRANSLATE_SUCCESS = "SITEINFO_UPDATE_TRANSLATE_SUCCESS";
export const SITEINFO_FAIL = "SITEINFO_FAIL";